import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import Lenis from "lenis";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Lore from "@/pages/Lore";
import Protocol from "@/pages/Protocol";
import Identity from "@/pages/Identity";
import Missions from "@/pages/Missions";
import Economy from "@/pages/Economy";
import Terminal from "@/pages/Terminal";
import Roadmap from "@/pages/Roadmap";
import Docs from "@/pages/Docs";
import Faq from "@/pages/Faq";

const PageTransition = ({ children }) => (
  <motion.main
    initial={{ opacity: 0, y: 18 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -12 }}
    transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.main>
);

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const AnimatedRoutes = () => {
  const location = useLocation();
  const page = (el) => <PageTransition>{el}</PageTransition>;
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={page(<Home />)} />
        <Route path="/about" element={page(<About />)} />
        <Route path="/lore" element={page(<Lore />)} />
        <Route path="/protocol" element={page(<Protocol />)} />
        <Route path="/identity" element={page(<Identity />)} />
        <Route path="/missions" element={page(<Missions />)} />
        <Route path="/economy" element={page(<Economy />)} />
        <Route path="/terminal" element={page(<Terminal />)} />
        <Route path="/roadmap" element={page(<Roadmap />)} />
        <Route path="/docs" element={page(<Docs />)} />
        <Route path="/faq" element={page(<Faq />)} />
        <Route path="*" element={page(<Home />)} />
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 0.95 });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <AnimatedRoutes />
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
